@use 'sass:map';
@use '../../variables' as *;
@use 'common/assets/scss/global' as *;
@import '@fortawesome/fontawesome-svg-core/styles.css';

button.drawer-toggle {
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: center;
  justify-content: center;
  height: $header-height;
  width: 72px;
  font-size: var(--#{$prefix}font-size-xxs);
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--#{$prefix}lighter-black);
  color: #fff;
  z-index: 3;
  transition:
    background-color 0.15s ease-out,
    gap 0.15s ease-out;

  > svg {
    height: 30px;
    width: 30px;
  }

  > span {
    opacity: 0;
    max-height: 0;
    margin-top: 0;
    visibility: hidden;
    transition:
      opacity 0.15s ease-out,
      max-height 0.15s ease-out;
  }

  &:hover,
  &:focus-visible {
    outline: none;
    background-color: var(--#{$prefix}primary);
    gap: 4px;

    > span {
      opacity: 1;
      max-height: 1.15em;
      visibility: visible;
    }
  }
}

.navigation-drawer {
  visibility: hidden;
  display: flex;
  flex-direction: column;
  transform: translateX(-$drawer-width);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: $drawer-width;
  background-color: var(--#{$prefix}lighter-black);
  color: #fff;
  font-size: var(--#{$prefix}font-size-sm);
  transition:
    visibility 0.15s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.15s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.15s cubic-bezier(0.4, 0, 0.2, 1);

  > div {
    visibility: hidden;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    height: $header-height;
    overflow: hidden;
    margin-left: $drawer-width;
    transition: visibility 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    > span {
      flex: 0 0 $drawer-expended-width - $drawer-width - 2 * 16;
      font-family: $sora;
      font-size: var(--#{$prefix}font-size-sm);
      font-weight: 600;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-wrap-style: balance;
      overflow: hidden;
      margin: 16px;
    }
  }

  > ul {
    flex: 0 0 auto;
    @include unstyled-list;

    > li {
      > a,
      > button {
        position: relative;
        display: flex;
        align-items: center;
        @include unstyled-link;
        color: inherit;
        height: 60px;
        width: 100%;
        text-align: start;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          border-top: 1px solid rgba($white, 5%);
        }

        > .active-indicator {
          display: none;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          border-left: 5px solid var(--#{$prefix}primary-dark);
        }

        > .icon {
          flex: 0 0 $drawer-width;
          display: inline-flex;
          justify-content: center;
          transition: opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

          > svg {
            height: 22px;
            width: 22px;
          }
        }

        > .text {
          flex: 0 0 $drawer-expended-width - $drawer-width;
          display: none;
        }

        &:not(.active) {
          &:hover,
          &:focus-visible {
            outline: none;
            color: var(--#{$prefix}primary-dark);

            > .active-indicator {
              display: unset;
            }
          }
        }
      }

      > a.active {
        color: var(--#{$prefix}body);
        background-color: var(--#{$prefix}body-bg);
        font-weight: bold;

        &:focus-visible {
          outline: none;

          > .active-indicator {
            display: unset;
            border-left: 5px solid var(--#{$prefix}body);
          }
        }
      }

      > button.active {
        background-color: var(--#{$prefix}primary);

        &:focus-visible {
          outline: none;

          > .active-indicator {
            display: unset;
            border-left: 5px solid var(--#{$prefix}body-bg);
          }
        }
      }

      > .favorites-dropdown {
        display: none;
      }
    }
  }

  &.expended {
    visibility: visible;
    width: $drawer-expended-width;
    transform: translateX(0);

    > div {
      visibility: visible;
    }

    > ul > li {
      > a,
      > button {
        > .icon {
          opacity: 0.33;
        }

        > .text {
          display: unset;
        }
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    &.visible {
      visibility: visible;
      transform: translateX(0);
    }

    > ul > li {
      > .favorites-bottom-sheet {
        display: none;
      }

      > .favorites-dropdown {
        display: unset;
      }
    }
  }
}
